import React, { useMemo } from 'react'
import { DadosRelDiaCtaPagar, bgLineGridColorDark, bgLineGridColorLight, corBgGrid } from '../../Utils/Types'
import { createTheme, ThemeProvider } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import moment from 'moment'
import { Funcoes } from '../../Utils/Funcoes'

type Props = {
    relContaAPagar: DadosRelDiaCtaPagar[],
    tipoFiltro: string,
}

interface RowData {
    dt_vencimento: string,
    dt_liquidacao: string,
    total: number,
    qtd_dup: number,
    acumulado: number
}

export const GridRelDiaContaPagar = React.memo(({ relContaAPagar, tipoFiltro }: Props) => {

    let user = useSelector(state => selectUser(state))

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'

    let theme = createTheme({
        palette: {
            mode: user.modeDark,

            background: {
                default:
                    user.modeDark === 'light'
                        ? '#fff' // modo claro
                        : '#475569', //modo escuro
            },
        },
    })

    let colunas = useMemo<MRT_ColumnDef<DadosRelDiaCtaPagar>[]>(
        () => [

            {
                accessorKey: 'dt_vencimento', header: `${tipoFiltro === 'A' ? 'Data Vencimento' : 'Data Liquidação'}`, size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {
                    const rowData = cell.row.original as RowData
                    return (<span>{moment(tipoFiltro === 'A' ? rowData.dt_vencimento : rowData.dt_liquidacao).format('DD/MM/YYYY')}</span>)
                }
            },

            {
                accessorKey: 'qtd_dup', header: 'Qtde de Duplicatas', size: 200, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.qtd_dup ? rowData.qtd_dup : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'total', header: 'Total (R$)', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.total ? Funcoes.numberFormat(rowData.total, 'currency') : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'acumulado', header: 'Acumulado (R$)', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.acumulado ? Funcoes.numberFormat(rowData.acumulado, 'currency') : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

        ], [tipoFiltro]
    )

    let table = useMaterialReactTable({
        columns: colunas,
        data: relContaAPagar,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: false,
        enableColumnFilters: false,
        enableHiding: false,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',

    })

    return (
        <>
            <ThemeProvider theme={theme}>
                <MaterialReactTable table={table} />
            </ThemeProvider>
        </>
    )

})